var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navItems)?_c('b-navbar',[_c('b-navbar-nav',_vm._l((_vm.navItems),function(item){return _c('b-nav-item',{key:item.id,attrs:{"to":{ name: item.routeName },"active":_vm.isActiveRoute(item)}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }